import axios from 'axios';

const urlMarginApi = process.env.REACT_APP_MARGIN_API
const TIMEOUT = 60000;

export const getConsignedPortalMarginApi = async (queryType, cpf) => {
  const token = sessionStorage.getItem('token');
  try {
    const { data } = await axios({
      method: 'GET',
        url: `${urlMarginApi}/${queryType}/margins?cpf=${cpf}`,
        headers: { Authorization: `Bearer ${token}` },
        timeout: TIMEOUT,
      });
    return data;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      return { errorMessage: `O tempo limite de espera ${TIMEOUT / 1000} segundos foi excedido.` };
    } else if (error.response) {
      if (error.response.data.message) {
        return { errorMessage: error.response.data.message };
      }
    }
    return { errorMessage: error.message };
  }
}